<!-- HEADER CONTENEDOR -->
<app-header-core *ngIf="dataCompany != undefined" [dataCompany]="dataCompany"></app-header-core>

<!-- FIN HEADER CONTENEDOR -->
<!-- BODY CONTENEDOR -->
<div class="container ecomm-bck">
    <div class="main-wrap">
        <div class="ecomm-hd">
            <a class="backstep" style="cursor: pointer;" (click)="goBack()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    [ngStyle]="{ 'color': colorPrimario }" class="bi bi-arrow-return-left" style="padding-right: 5px;"
                    viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                        d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z" />
                </svg> [Back to search results]</a>
            <!--<img src=" {{logoCruise}}{{ storeLocalInquireService.getLogoBoat() }}" width="118" height="28" alt="Logo Boat"/>-->
            <strong *ngIf="storeLocalInquireService.getTextTempContPromotion() != 'Charter'">{{ textDaysCruise }} Cruise
                from
                US${{ storeLocalInquireService.getPromoPrice() | number:'3.0-0' }} <span
                    *ngIf="storeLocalInquireService.getPromoPrice() != storeLocalInquireService.getRackPrice()">(<u
                        style="text-decoration: line-through">US${{ storeLocalInquireService.getRackPrice() |
                        number:'3.0-0'
                        }}</u>)</span> p/person</strong>
            <strong
                *ngIf="storeLocalInquireService.getTextTempContPromotion() === 'Charter' && storeLocalInquireService.getPromotion().length > 0">{{
                textDaysCruise }} Cruise from Charter Only US${{ storeLocalInquireService.getPromoPrice() |
                number:'3.0-0'
                }}</strong>
            <strong
                *ngIf="storeLocalInquireService.getTextTempContPromotion() === 'Charter' && storeLocalInquireService.getPromotion().length == 0">{{
                textDaysCruise }} Cruise from Charter Only US${{ storeLocalInquireService.getRackPrice() |
                number:'3.0-0'
                }}</strong>
            <br />
            <!--      {{ promocion }} + {{ textContPromotion }}*-->
            <span *ngIf="textPromo !== 'none'">{{ storeLocalInquireService.getPromotion() }}</span>
        </div>
        <div id="finish">
            <aside>
                <img src="{{ logoCruise + storeLocalInquireService.getImageBoat() }}" width="361" height="180"
                    alt="{{ storeLocalInquireService.getBoat() }}" />
                <h4 class="tourdet">Tour Details <img src="{{logoCruise}}{{ storeLocalInquireService.getLogoBoat() }}"
                        style="width: 7rem; float: right;" alt="Logo Boat" /></h4>
                <table width="100%">
                    <tbody>
                        <tr>
                            <th colspan="2" scope="col">Travel Dates</th>
                        </tr>
                        <tr>
                            <td><strong>Start Date:</strong></td>
                            <!--              <td>{{ fechaArrivo }} *</td>-->
                            <td>{{ storeLocalInquireService.getStartDate() | date: 'MMM dd, yyyy' }} </td>
                        </tr>
                        <tr>
                            <td><strong>End Date:</strong></td>
                            <!--              <td>{{ fechaSalida }} *</td>-->
                            <td>{{ storeLocalInquireService.getEndDate() | date: 'MMM dd, yyyy' }} </td>
                        </tr>
                        <tr>
                            <th colspan="2" scope="col">Tour Details</th>
                        </tr>
                        <tr>
                            <td><strong>Itinerary:</strong></td>
                            <!--            <td>{{ textItinerary }} (<a href="#">more info</a>)</td>-->
                            <td>{{ textItinerary }}</td>
                        </tr>
                        <tr>
                            <td><strong>From:</strong></td>
                            <td *ngIf="storeLocalInquireService.getTextTempContPromotion() != 'Charter'">US${{
                                storeLocalInquireService.getPromoPrice() | number:'3.0-0' }} <span
                                    *ngIf="storeLocalInquireService.getPromoPrice() != storeLocalInquireService.getRackPrice()">(<u
                                        style="text-decoration: line-through">US${{
                                        storeLocalInquireService.getRackPrice() | number:'3.0-0'
                                        }}</u>)</span> p/person</td>
                            <td
                                *ngIf="storeLocalInquireService.getTextTempContPromotion() === 'Charter' && storeLocalInquireService.getPromotion().length == 0">
                                US${{ storeLocalInquireService.getRackPrice() | number:'3.0-0' }}</td>
                            <td
                                *ngIf="storeLocalInquireService.getTextTempContPromotion() === 'Charter' && storeLocalInquireService.getPromotion().length > 0">
                                US${{ storeLocalInquireService.getPromoPrice() | number:'3.0-0' }}</td>
                        </tr>

                        <tr *ngIf="textPromo !== 'none'">
                            <td><strong>Promotion:</strong></td>
                            <td>{{ storeLocalInquireService.getPromotion() }} {{
                                storeLocalInquireService.getContPromotion() }}</td>
                        </tr>
                        <tr *ngIf="storeLocalInquireService.getAditionalServices().length > 0">
                            <th colspan="2" scope="col">Aditional Services</th>
                        </tr>
                        <tr *ngFor="let serv of storeLocalInquireService.getAditionalServices()">
                            <td colspan="2">
                                <small>&raquo; {{ serv }}</small>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />

            </aside>
            <div class="modules-ecomm">
                <div class="headmod" [ngStyle]="{ 'background-color': storeLocalInquireService.getMainColor() }">Your
                    online hold was successfully placed
                </div>
                <div class="mod-content active" style="padding-top: 10px;">

                    <blockquote>
                        <p><strong>Thank you for your interest in the {{ storeLocalInquireService.getBoat() }}
                                Yacht.</strong> One of our representatives will contact you within 24 hours. If you have
                            any urgent questions or comments, please call us at {{dataCompany?.phone}}
                            We look forward to speaking with you!</p>
                        <p>&nbsp;</p>
                    </blockquote>
                    <!-- H5 Tag-->
                    <h3>Important Notes:</h3>
                    <p>1. Certain filters and security settings may prevent our emails responses from arriving in your
                        inbox, so please be sure to check your junk, trash or spam folders.</p>


                    <p>Thanks again.</p>
                    <h3>&nbsp;</h3>
                    <div class="row" style="display: flex;">
                        <div class="back">
                            <a class="backstep" style="cursor: pointer;" (click)="goBack()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                    [ngStyle]="{ 'color': colorPrimario }" class="bi bi-arrow-return-left"
                                    style="padding-right: 5px;" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z" />
                                </svg>[Back to search results]</a>
                        </div>
                        <div class="home">

                            <a href="https://{{ dataCompany?.webSite }}">Go back home</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
    </div>
</div>
<!-- FIN BODY CONTENEDOR -->
<div id="footerThanks">
    <!-- FOOTER CONTENEDOR -->
    <div class="container" [ngStyle]="{ 'background-color': storeLocalInquireService.getFooterColor() }">
        <hr />
        <div class="post-footer">
            <div class="wrap2">
                <a [ngClass]="isTooDark(storeLocalInquireService.getFooterColor()) ? 'darkMode' : 'lightMode'"
                    href="https://galavail.com/galavail-web/" class="galavail" style="width: 14%;height: 29px;margin-bottom: 20px;"></a>
                <p [ngClass]="isTooDark(storeLocalInquireService.getFooterColor()) ? 'darkMode' : 'lightMode'"
                    style="font-size: 12px;">{{
                    todayDate }} ©
                    <a [ngClass]="isTooDark(storeLocalInquireService.getFooterColor()) ? 'darkMode' : 'lightMode'"
                        *ngIf="storeLocalInquireService.getCompany()"
                        [href]="'https://'+storeLocalInquireService.getWebsite()">{{
                        storeLocalInquireService.getNameCompany() != undefined ?
                        storeLocalInquireService.getNameCompany() : ''
                        }}</a> &nbsp;
                    <!--&bull;&nbsp;
          <a [ngClass]="isTooDark(storeLocalInquireService.getFooterColor()) ? 'darkMode' : 'lightMode'" *ngIf="storeLocalInquireService.getCompany()" [href]="'https://'+storeLocalInquireService.getPrivacyUrl()" target="_blank">Privacy Policy</a>-->
                    <a [ngClass]="isTooDark(storeLocalInquireService.getFooterColor()) ? 'darkMode' : 'lightMode'"
                        *ngIf="storeLocalInquireService.getCompany()" href="#" target="_blank">Privacy Policy</a>
                    &nbsp;&bull;&nbsp;
                    <a [ngClass]="isTooDark(storeLocalInquireService.getFooterColor()) ? 'darkMode' : 'lightMode'"
                        [href]="mailTo">{{ storeLocalInquireService.getCompany() != undefined ?
                        storeLocalInquireService.getInfoMail() : '' }}</a>
                </p>
            </div>
        </div>
    </div>
    <!-- FIN FOOTER CONTENEDOR -->
</div>